import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  LEADERBOARD: {
    LIST_ALL: {
      REFRESH: 'LEADERBOARD.LIST_ALL.REFRESH',
      REFRESHING: 'LEADERBOARD.LIST_ALL.REFRESHING',
      REFRESHED: 'LEADERBOARD.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'LEADERBOARD.LIST_ALL.REFRESH_ERROR'
    }
  }
};

export const ENDPOINTS = {
  LEADERBOARD: {
    GET_LIST: '/store/app/data?service=ecoxurf-LEADERBOARD&userId=ecoxurf&group=ecoxurf'
  }
};

export const LEADERBOARD = {
  LOTTIES: {
      EMPTY: emptyTransactions,
      LOADING_ERROR: loadingError
  }
};
